import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const FormalEnforcementActionsTable = ({ data }) => {
  let total = data.reduce((n, { value }) => n + value, 0);

  let columns = React.useMemo(
    () => [
      {
        Header: "Enforcement Action Type",
        Footer: "Total ",
        accessor: "name"
      },

      {
        Header: "Count",
        Footer: total,
        accessor: "value"
      },
      {
        Header: "Percentage",
        accessor: (d) => {
          return ((d.value / total) * 100).toFixed(2) + "%";
        },
        Footer: ""
      }
    ],
    [total]
  );

  useEffect(() => {
    if (data && data.length) console.log("ENF: ", data);
  }, [data]);

  return (
    <>
      <Row>
        <Col>
          <h3>Formal Enforcement Actions</h3>
        </Col>
      </Row>
      <Row>
        <Col>{data.length > 0 ? <DtsReactTable columns={columns} data={data} showFooter headerColor='ddw' /> : ""}</Col>
      </Row>
    </>
  );
};

export default FormalEnforcementActionsTable;
